(function () {
    'use strict';

    function crmActionsDataService($http) {

        var baseUrl = '[BuildifyApiHost]/api/crm/';

        function assignAccountManagers(entityId, assignedAccountManagers) {
            return $http.put(baseUrl + 'assignaccountmanagers/' + entityId, assignedAccountManagers).then(function (response) {
                return response.data;
            });
        };

        return {
            assignAccountManagers: assignAccountManagers
        }
    }

    crmActionsDataService.$inject = ['$http'];

    angular.module('ecap.crm').service('crmActionsDataService', crmActionsDataService);
})();
